/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/EditAutomation/TriggerType/CustomResourceInsert/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let constantData = 'pre'
let automationTriggerTypeValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'trigger_type',
})
let aggregateData = fromAggregate.equals(constantData, automationTriggerTypeValueData)
let constantData1 = 'automatic'
let automationAutomationTypeValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'automation_type',
})
let aggregateData1 = fromAggregate.equals(constantData1, automationAutomationTypeValueData)
let constantData2 = 'post'
let automationTriggerTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'trigger_type',
})
let aggregateData2 = fromAggregate.equals(constantData2, automationTriggerTypeValueData1)
let constantData3 = 'automatic'
let automationAutomationTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'automation_type',
})
let aggregateData3 = fromAggregate.equals(constantData3, automationAutomationTypeValueData1)
let resourcesValueData = fromData.useDataValue({ viewPath,
context: 'resources',
})
let automationCustomResourceTypeValueData = fromData.useDataValue({ viewPath,
context: 'automation',
path: 'custom_resource_type',
})
let onChange = fromHelpers.useOnChange({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-2-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-3-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-4-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-5-Z1Yf8zk': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--mr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Start this"
/>
</div>
<Radial
  viewPath={`${viewPath}/Radial`}
 paddingBottom={0}
 paddingTop={0}
 text="Before"
 data="'pre'"
 data="automation.trigger_type"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData}
 data="'automatic'"
 data="automation.automation_type"
 aggregate="/Data/aggregate.js equals"
 isDisabled={aggregateData1}
/>
<Radial
  viewPath={`${viewPath}/Radial`}
 paddingBottom={0}
 paddingTop={0}
 text="After"
 marginRight={dtSpaceXs}
 data="'post'"
 data="automation.trigger_type"
 aggregate="/Data/aggregate.js equals"
 isSelected={aggregateData2}
 data="'automatic'"
 data="automation.automation_type"
 aggregate="/Data/aggregate.js equals"
 isDisabled={aggregateData3}
/>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 size="small"
 marginTop={0}
 data="resources"
 from={resourcesValueData}
 data="automation.custom_resource_type"
 value={automationCustomResourceTypeValueData}
 onChange={onChange}
>
{childProps => (
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
 flexGrow={0}
 maxWidth={260}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
)}
</TysiaSelectOne>
</div>
{children}
</React.Fragment>)
}